var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomInClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zoom-in",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_36",
    "data-name": "\\u692D\\u5706 36",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#226fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_37",
    "data-name": "\\u692D\\u5706 37",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(2 2)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1180",
    "data-name": "\\u7EC4 1180"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_38",
    "data-name": "\\u692D\\u5706 38",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(11 11)",
    strokeWidth: 1.5,
    stroke: "#226fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_35",
    "data-name": "\\u76F4\\u7EBF 35",
    x2: 3,
    y2: 3,
    transform: "translate(23 23)",
    fill: "none",
    stroke: "#226fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_36",
    "data-name": "\\u76F4\\u7EBF 36",
    x2: 4,
    transform: "translate(16 18)",
    fill: "none",
    stroke: "#226fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_37",
    "data-name": "\\u76F4\\u7EBF 37",
    y2: 4,
    transform: "translate(18 16)",
    fill: "none",
    stroke: "#226fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInClick);
export default __webpack_public_path__ + "static/media/zoom-in-click.48408674407666ad2662655b01be7461.svg";
export { ForwardRef as ReactComponent };